import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
//import './layouts/UserDashboard/styles/Modal.css';
//import './styles/modal.css';

import PrivateRoute from "./services/PrivateRoute";
import ToastConfig from "./configs/toastConfig"; // Import Global Toast Config
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './assets/styles/WorkflowAssignment.css'; // Global modal styles for WorkflowAssignment

import UnauthorizedPage from "./pages/UnauthorizedPage";
import LoginPage from "./pages/LoginPage";
import { AuthProvider } from "./context/AuthContext";
import DynamicPage from "./pages/DynamicPage"; // Dynamically loads pages
import UserDashboard from "./layouts/UserDashboard/UserDashboard";
import AdminDashboard from "./layouts/AdminDashboard/AdminDashboard";
import TaskDetailPage from "./components/TaskDetailPage";
import UserOrgInfo from "./components/UserOrgInfo";

const App = () => {
    return (
        <><ToastConfig />
        <AuthProvider>
            <Router>
                <div className="App">
                    <ToastContainer position="top-right" autoClose={3000} />
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/unauthorized" element={<UnauthorizedPage />} />
                        {/* Protected Admin Routes */}
                        <Route
                            path="/admin-dashboard/*"
                            element={
                                <PrivateRoute allowedRoles={["0"]}>
                                   
                                        <AdminDashboard useStaticMenu={true}/>
                                   
                                </PrivateRoute>
                            }
                        >
                            {/* Dynamic Nested Pages */}
                            <Route path=":pageName" element={<DynamicPage />} />
                        </Route>
                        {/* Protected User Routes */}
                        <Route
                            path="/user-dashboard/*"
                            element={
                                <PrivateRoute allowedRoles={["0","1","2"]}>
                                   
                                        <UserDashboard/>
                                   
                                </PrivateRoute>
                            }
                        >
                            {/* Dynamic Nested Pages */}
                            <Route path=":pageName" element={<DynamicPage />} />
                            {/* Task Detail Route */}
                            <Route path="task/:taskId" element={<TaskDetailPage />} />
                            {/* User Organization Info Route */}
                            <Route path="org-info" element={<UserOrgInfo />} />
                        </Route>
                        {/* Redirect root to login */}
                        <Route path="/" element={<Navigate to="/login" />} />
                       
                        {/* Catch-all redirect */}
                        <Route path="*" element={<Navigate to="/login" />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
        </>
    );
};

export default App;